












import { Component, Vue } from 'vue-property-decorator';
import Navigation from '@/components/Navigation.vue';
import Awards from '@/components/Awards.vue';
import Footer from '@/components/Footer.vue';

@Component({
  components: {
    Navigation,
    Awards,
    Footer,
  },
})
export default class App extends Vue {
  private drawer = false;

  private bg = 'transparent';

  protected mounted() {
    window.onscroll = () => {
      this.changeColor();
    };
  }

  private changeColor() {
      if (
        document.body.scrollTop > 100 ||
        document.documentElement.scrollTop > 100
      ) {
        this.bg = 'white';
      } else {
        this.bg = 'transparent';
      }
  }
}
